import React from 'react';
import { Link } from 'react-router-dom';
import Meta from "@components/Meta/Meta";

const NotFound = () => (
  <>
  <Meta
    title="Página No Encontrada"
    is404={true}
  />
  <div className='container mt-5 mb-5 pt-5 pb-5'>
    <h1>404 - Contenido no encontrado!</h1>
    <div className='mt-5 mb-5'><strong style={{color:"#ff0099"}}>La dirección URL que buscas NO EXISTE!!</strong></div>
    <Link to="/">🏠 VOLVER AL INICIO</Link>
  </div>
  </>
);

export default NotFound;